<!-- CLIENT INVOICES MODAL -->
<ng-template #clientInvoiceModal>
  <div class="table-modal__table d-flex flex-column justify-content-between h-100 mt-12">
    <rc-table [config]="tableConfig()">

      <kendo-grid-column [width]="64">
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container
            *ngTemplateOutlet="actionMenu; context: { $implicit: dataItem }">
          </ng-container>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="documentNumber" title="{{ 'INVOICE_NUMBER' | translate }}">
        <!--      <><ng-template kendoGridFilterCellTemplate let-filter let-params="params" let-reload="reload" let-column="column">-->
        <!--      <kendo-textbox-->
        <!--        (valueChange)="setCustomFilter($event, 'documentNumber', params, reload)"-->
        <!--        [value]="getParamValue('documentNumber', params)"></kendo-textbox>-->
        <!--      </ng-template></>-->
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="d-flex justify-content-start">
            <a class="rc-string-button !k-text-no-underline d-flex" [href]="'/sales' + dataItem['@id']" target="_blank">
              <span class="!k-text-underline underline-offset-2">
                {{ dataItem.documentNumber | uppercase }}
              </span>
              <i class="rc-icon-external-link !k-text-no-underline ps-1 fc-neutral-800"></i>
            </a>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="invoiceDate" title="{{ 'INVOICE_DATE' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.invoiceDate | kendoDate: "dd/MM/yyyy" }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="total" title="{{ 'TOTAL' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.total ?? 0 | kendoNumber: decimalFormat }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="clientName" title="{{ 'CLIENT' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.clientName }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="reference" title="{{ 'REFERENCE' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.reference }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="status" title="{{ 'STATUS' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container
            *ngTemplateOutlet="statusBadge; context: { $implicit: dataItem }">
          </ng-container>
        </ng-template>
      </kendo-grid-column>
    </rc-table>

    <ng-container *ngTemplateOutlet="closeAction"></ng-container>
  </div>
</ng-template>

<!-- SUPPLIER INVOICES MODAL -->
<ng-template #supplierInvoiceModal>
  <div class="table-modal__table d-flex flex-column justify-content-between h-100 mt-12">
    <rc-table [config]="tableConfig()">

      <kendo-grid-column [width]="64">
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container
            *ngTemplateOutlet="actionMenu; context: { $implicit: dataItem }">
          </ng-container>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="documentNumber" title="{{ 'INVOICE_NUMBER' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="d-flex justify-content-start">
            <a class="rc-string-button !k-text-no-underline d-flex" [href]="'/purchase' + dataItem['@id']" target="_blank">
              <span class="!k-text-underline underline-offset-2">
                {{ dataItem.documentNumber | uppercase }}
              </span>
              <i class="rc-icon-external-link !k-text-no-underline ps-1 fc-neutral-800"></i>
            </a>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="invoiceDate" title="{{ 'INVOICE_DATE' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.invoiceDate | kendoDate: "dd/MM/yyyy" }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="total" title="{{ 'TOTAL' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.total ?? 0 | kendoNumber: decimalFormat }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="supplierName" title="{{ 'SUPPLIER' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.supplierName }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="reference" title="{{ 'REFERENCE' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.reference }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="status" title="{{ 'STATUS' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container
            *ngTemplateOutlet="statusBadge; context: { $implicit: dataItem }">
          </ng-container>
        </ng-template>
      </kendo-grid-column>
    </rc-table>

    <ng-container *ngTemplateOutlet="closeAction"></ng-container>
  </div>
</ng-template>

<!-- CLIENT CREDIT NOTE MODAL -->
<ng-template #clientCreditNoteModal>
  <div class="table-modal__table d-flex flex-column justify-content-between h-100 mt-12">
    <rc-table [config]="tableConfig()">

      <kendo-grid-column [width]="64">
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container
            *ngTemplateOutlet="actionMenu; context: { $implicit: dataItem }">
          </ng-container>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="documentNumber" title="{{ 'CREDIT_NUMBER' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="d-flex justify-content-start">
            <a class="rc-string-button !k-text-no-underline d-flex" [href]="'/sales' + dataItem['@id']" target="_blank">
              <span class="!k-text-underline underline-offset-2">
                {{ dataItem.documentNumber | uppercase }}
              </span>
              <i class="rc-icon-external-link !k-text-no-underline ps-1 fc-neutral-800"></i>
            </a>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="creditNoteDate" title="{{ 'CREDIT_DATE' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.creditNoteDate | kendoDate: "dd/MM/yyyy" }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="total" title="{{ 'TOTAL' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.total ?? 0 | kendoNumber: decimalFormat }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="clientName" title="{{ 'CLIENT' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.clientName }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="reference" title="{{ 'REFERENCE' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.reference }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="status" title="{{ 'STATUS' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container
            *ngTemplateOutlet="statusBadge; context: { $implicit: dataItem }">
          </ng-container>
        </ng-template>
      </kendo-grid-column>
    </rc-table>

    <ng-container *ngTemplateOutlet="closeAction"></ng-container>
  </div>
</ng-template>

<!-- CLIENT INVOICE ITEM MODAL -->
<ng-template #clientInvoiceItemModal>
  <div class="table-modal__table d-flex flex-column justify-content-between h-100 mt-12">
    <rc-table [config]="tableConfig()">

      <kendo-grid-column [width]="64">
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container
            *ngTemplateOutlet="actionMenu; context: { $implicit: dataItem }">
          </ng-container>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="documentNumber" title="{{ 'INVOICE_NUMBER' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="d-flex justify-content-start">
            <a class="rc-string-button !k-text-no-underline d-flex" [href]="'/sales' + dataItem.clientInvoice" target="_blank">
              <span class="!k-text-underline underline-offset-2">
                {{ dataItem.clientInvoiceDocumentNumber | uppercase }}
              </span>
              <i class="rc-icon-external-link !k-text-no-underline ps-1 fc-neutral-800"></i>
            </a>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="{{ 'ARTICLE' | translate }} / {{ 'SUPPLIER' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="d-flex flex-column ">
            <div class="fw-500 h-unset">{{ dataItem.articleNumber ?? "-" }}</div>
            <div class="fc-neutral-600">{{ dataItem.supplierName ?? "-" }}</div>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="amount" title="{{ 'AMOUNT' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.amount ?? 0 | kendoNumber: amountFormat }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="retailPrice" title="{{ 'PRICE_EXCL_VAT' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.retailPrice ?? 0 | kendoNumber: decimalFormat  }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="conditionString" title="{{ 'CONDITION' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.conditionString }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="lineTotal" title="{{ 'LINE_TOTAL' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.lineTotal ?? 0 | kendoNumber: decimalFormat  }}
        </ng-template>
      </kendo-grid-column>
    </rc-table>

    <ng-container *ngTemplateOutlet="closeAction"></ng-container>
  </div>
</ng-template>

<!-- SUPPLIER INVOICE ITEM MODAL -->
<ng-template #supplierInvoiceItemModal>
  <div class="table-modal__table d-flex flex-column justify-content-between h-100 mt-12">
    <rc-table [config]="tableConfig()">

      <kendo-grid-column [width]="64">
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container
            *ngTemplateOutlet="actionMenu; context: { $implicit: dataItem }">
          </ng-container>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="documentNumber" title="{{ 'INVOICE_NUMBER' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="d-flex justify-content-start">
            <a class="rc-string-button !k-text-no-underline d-flex" [href]="'/purchase' + dataItem.supplierInvoice" target="_blank">
              <span class="!k-text-underline underline-offset-2">
                {{ dataItem.supplierInvoiceDocumentNumber | uppercase }}
              </span>
              <i class="rc-icon-external-link !k-text-no-underline ps-1 fc-neutral-800"></i>
            </a>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="{{ 'ARTICLE' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.articleNumber ?? "-" }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="amount" title="{{ 'AMOUNT' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.amount ?? 0 | kendoNumber: amountFormat }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="basicNetPrice" title="{{ 'BASIC_PRICE' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.basicNetPrice ?? 0 | kendoNumber: decimalFormat  }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="conditionString" title="{{ 'DISCOUNTS' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.conditionString ?? "-" }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="purchasePrice" title="{{ 'NET_PRICE' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.purchasePrice ?? 0 | kendoNumber: decimalFormat  }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="taxPrice" title="{{ 'TAX' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.taxPrice ?? 0 | kendoNumber: decimalFormat  }}
        </ng-template>
      </kendo-grid-column>
    </rc-table>

    <ng-container *ngTemplateOutlet="closeAction"></ng-container>
  </div>
</ng-template>

<!-- MODAL TEMPLATE SECTIONS -->
<ng-template #actionMenu let-dataItem>
    <kendo-dropdownbutton
      class="no-bg-dropdown"
      iconClass="rc-icon-vertical-dots"
      [data]="tableConfig().actionMenuItems$ | async"
      (itemClick)="tableConfig().onActionMenuItemClick?.($event, dataItem['@id'], getPropField(dataItem))">
    </kendo-dropdownbutton>
</ng-template>

<ng-template #statusBadge let-dataItem>
  <rc-badge
    [label]="(dataItem.status | clientInvoiceStatusBadge : 'label') | translate"
    [color]="(dataItem.status | clientInvoiceStatusBadge : 'badge') | translate">
  </rc-badge>
</ng-template>

<ng-template #closeAction>
  <kendo-dialog-actions>
    <div class="d-flex justify-content-end gap-16">
      <button kendoButton class="g-start-10 string-button" (click)="close()">
        {{ "CLOSE" | translate | capitalize }}
      </button>
    </div>
  </kendo-dialog-actions>
</ng-template>
